var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 3.37508C24.7977 4.13499 23.6049 4.71621 22.3425 5.09633C21.665 4.31728 20.7645 3.76511 19.7629 3.5145C18.7613 3.26389 17.7069 3.32693 16.7423 3.69509C15.7777 4.06326 14.9495 4.71878 14.3696 5.57301C13.7897 6.42724 13.4862 7.43896 13.5 8.47133V9.59633C11.523 9.6476 9.56393 9.20912 7.79738 8.31996C6.03084 7.4308 4.51161 6.11855 3.375 4.50008C3.375 4.50008 -1.125 14.6251 9 19.1251C6.68309 20.6978 3.92305 21.4864 1.125 21.3751C11.25 27.0001 23.625 21.3751 23.625 8.43758C23.624 8.12422 23.5938 7.81163 23.535 7.50383C24.6832 6.37151 25.4934 4.94188 25.875 3.37508V3.37508Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9b24d70ebb1b309d1b94506070ad2f97.svg";
export { ForwardRef as ReactComponent };